/* eslint-disable prefer-const */
import React, { useRef, useState, createRef } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button } from '@material-ui/core/'
import EmailEditor from 'react-email-editor'
import apiAdmin from '../../../../../../../api/admin'
import './index.scss'

const AddMeil = ({ setStep, createTemplate, updateTemplate, template, setTemlate, mergeTags, setMergeTags }) => {
  const emailEditorRef = useRef(null)
  const { user } = useSelector(({ session }) => session)
  const uploadBtn = createRef()
  const [imgsUrl, setImgUrl] = useState({})
  const fileArrey = []

  const copySrc = () => {
    navigator.clipboard.writeText(imgsUrl?.src)
    setImgUrl([])
  }

  const exportHtml = () => {
    emailEditorRef.current.editor.exportHtml(data => {
      const { design, html } = data
      if (template?.uuid) {
        updateTemplate(template?.uuid, design, html)
      } else {
        createTemplate(design, html)
      }
    })
  }

  const onLoad = () => {
    if (template?.uuid) {
      setTimeout(() => {
        emailEditorRef?.current?.editor?.loadDesign(template?.json)
      }, 2000)
    } else if (template?.uuid === null) {
      setTimeout(() => {
        emailEditorRef?.current?.editor?.loadDesign(template?.json)
      }, 2000)
    }
  }

  const upload = () => {
    uploadBtn?.current?.setAttribute('multiple', true)
    uploadBtn?.current?.setAttribute('accept', '.jpeg, .png, .svg, .jpg, .gif, .pdf')
    uploadBtn?.current?.click()
  }

  const uploadImgsStorys = img => {
    apiAdmin.uploadFilesMail(user?.accessKey, [img])
      .then(({ data }) => setImgUrl(...data?.images))
      .catch(error => console.error(error))
  }

  const handleChange = e => {
    if (!e?.target?.files?.length) {
      return
    }
    let files = e.target.files
    fileArrey.push(files)
    let reader
    for (var i = 0; i < fileArrey[0].length; i++) {
      reader = new FileReader()
      reader.readAsDataURL(fileArrey[0][i])
      reader.onload = event => {
        uploadImgsStorys({
          data: event?.target?.result,
          contentType: event?.target?.result?.split(';')?.[0]?.split(':')?.[1],
        })
      }
    }
  }

  return (
    <Grid className='wrapperEmailEditor'>
      {mergeTags?.user?.name && (
        <EmailEditor
          minHeight='90%'
          ref={emailEditorRef}
          onLoad={onLoad}
          projectId='32541'
          templateId='[TEMPLATE-ID]'
          options={{
            mergeTags: {
              ...mergeTags,
            },
          }}
        />
      )}
      <Grid className='boxBtmMailing'>
        <Button
          variant='contained'
          color='primary'
          className='btnCansel'
          onClick={() => {
            setStep(0)
            setTemlate({})
            setMergeTags(null)
          }}
        >
          CANSEL
        </Button>
        {imgsUrl?.src ? (
          <Button onClick={copySrc} className='btnAddImgs' variant='contained' color='primary'>
            Copy
          </Button>
        ) : (
          <>
            <input onChange={handleChange} className='uploadInputImg' id='selectImage' type='file' ref={uploadBtn} />
            <Button onClick={upload} className='btnAddImgs' variant='contained' color='primary'>
              Upload file
            </Button>
          </>
        )}
        <Button
          variant='contained'
          color='primary'
          className='btnSave'
          onClick={exportHtml}
        >
          Save template
        </Button>
      </Grid>
    </Grid>
  )
}

export default AddMeil
